export default "__VITE_ASSET__k0ddYnvF__"